import { Box, Grid } from "@mui/material"
import MenuTab from "../../../component/tabs/MenuTab"
import StabilimentiForm from "./StabilimentiForm"
import TerreniForm from "../Terreni/TerreniForm"
import { useSelector } from "react-redux"
// import StabilimentoForm from "./StabilimentoForm/StabilimentoForm"
// import SubImposteForm from "../Imposte/SubImposteForm"

const SubStructureStabiliment = ({ Component }) => {
    const singleData = useSelector((state) => state?.stabilimenti?.singleStabilimento);
    console.log("singo stabilimenti", singleData);
    return (
        <>
            <div className="pageTemplate">

                <Grid container spacing={3}>
                    <Grid size={{lg:3, md:4, xs:12}}>
                        {/* <StabilimentoForm /> */}
                         < StabilimentiForm singleData={singleData} />

                    </Grid>
                    <Grid size={{lg:9, md:8, xs:12}}>
                        <Box className="TemplateForm__right">
                            <MenuTab subStructureStabiliment={true} />
                        </Box>
                        {Component && <Component />}
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default SubStructureStabiliment
